export const COMMON_FAILURE = 'COMMON_FAILURE' as const;

export const LOG_IN_INITIAL = 'LOG_IN_INITIAL' as const;

export const HOME_INITIAL = 'HOME_INITIAL' as const;

export const UNPAID_OPERATION_CHECK_INITIAL = 'UNPAID_OPERATION_CHECK_INITIAL' as const;

// 30_クレカ切り替え操作日チェックAPI
export const GET_CREDIT_CHANGE_CHECK_REQUEST = 'GET_CREDIT_CHANGE_CHECK_REQUEST' as const;

// 26_メニュー取得API
export const GET_MEMBER_MENU_REQUEST = 'GET_MEMBER_MENU_REQUEST' as const;
export const GET_MEMBER_MENU_INITIAL = 'GET_MEMBER_MENU_INITIAL' as const;

// 104.メニュー利用可否チェックAPI
export const GET_SHOP_BUTTON_INITIAL = 'GET_SHOP_BUTTON_INITIAL' as const;

// 29.休会申込状態取得API
export const GET_RECESS_STATUS_INITIAL = 'GET_RECESS_STATUS_INITIAL' as const;

// 105.会員管理移籍処理チェックAPI
export const GET_MEMBER_TRANSFER_STATUS_INITIAL = 'GET_MEMBER_TRANSFER_STATUS_INITIAL' as const;

// スケジュール管理画面でスケジュール取得API
export const GET_SCHEDULE_REQUEST = 'GET_SCHEDULE_REQUEST' as const;
export const GET_SCHEDULE_SUCCESS = 'GET_SCHEDULE_SUCCESS' as const;
export const GET_SCHEDULE_FAILURE = 'GET_SCHEDULE_FAILURE' as const;
export const GET_SCHEDULE_INITIAL = 'GET_SCHEDULE_INITIAL' as const;

// スケジュール予約確認でスケジュール取得API
export const GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST = 'GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST' as const;
export const GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS = 'GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS' as const;
export const GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE = 'GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE' as const;
export const GET_SCHEDULE_RESERVATION_CONFIRM_INITIAL = 'GET_SCHEDULE_RESERVATION_CONFIRM_INITIAL' as const;

export const SCHEDULE_DISPATCH = 'SCHEDULE_DISPATCH' as const;
export const GET_SCHEDULE_RESERVATION_DISPATCH = 'GET_SCHEDULE_RESERVATION_DISPATCH' as const;
export const GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH = 'GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH' as const;

export const POST_SCHEDULE_RESERVATION_UPDATE_INITIAL = 'POST_SCHEDULE_RESERVATION_UPDATE_INITIAL' as const;

export const VISITOR_REGISTER_DISPATCH = 'VISITOR_REGISTER_DISPATCH' as const;
export const VISITOR_REGISTER_DISPATCH_INIT = 'VISITOR_REGISTER_DISPATCH_INIT' as const;
export const VISITOR_REGISTER_CONFIRM_DISPATCH = 'VISITOR_REGISTER_CONFIRM_DISPATCH' as const;
export const VISITOR_REGISTER_CONFIRM_DISPATCH_INIT = 'VISITOR_REGISTER_CONFIRM_DISPATCH_INIT' as const;
export const POST_VISITOR_REGISTER_REQUEST = 'POST_VISITOR_REGISTER_REQUEST' as const;
export const POST_VISITOR_REGISTER_SUCCESS = 'POST_VISITOR_REGISTER_SUCCESS' as const;
export const POST_VISITOR_REGISTER_FAILURE = 'POST_VISITOR_REGISTER_FAILURE' as const;
export const POST_VISITOR_REGISTER_INITIAL = 'POST_VISITOR_REGISTER_INITIAL' as const;

export const GET_VISITOR_RESERVATION_CHECK_REQUEST = 'GET_VISITOR_RESERVATION_CHECK_REQUEST' as const;
export const GET_VISITOR_RESERVATION_CHECK_SUCCESS = 'GET_VISITOR_RESERVATION_CHECK_SUCCESS' as const;
export const GET_VISITOR_RESERVATION_CHECK_FAILURE = 'GET_VISITOR_RESERVATION_CHECK_FAILURE' as const;
export const GET_VISITOR_RESERVATION_CHECK_INITIAL = 'GET_VISITOR_RESERVATION_CHECK_INITIAL' as const;

export const GET_VISITOR_SIMPLE_AUTH_REQUEST = 'GET_VISITOR_SIMPLE_AUTH_REQUEST' as const;
export const GET_VISITOR_SIMPLE_AUTH_SUCCESS = 'GET_VISITOR_SIMPLE_AUTH_SUCCESS' as const;
export const GET_VISITOR_SIMPLE_AUTH_FAILURE = 'GET_VISITOR_SIMPLE_AUTH_FAILURE' as const;
export const GET_VISITOR_SIMPLE_AUTH_INITIAL = 'GET_VISITOR_SIMPLE_AUTH_INITIAL' as const;

// 予約履歴取得
export const GET_RESERVE_HISTORY_REQUEST = 'GET_RESERVE_HISTORY_REQUEST' as const;
export const GET_RESERVE_HISTORY_SUCCESS = 'GET_RESERVE_HISTORY_SUCCESS' as const;
export const GET_RESERVE_HISTORY_FAILURE = 'GET_RESERVE_HISTORY_FAILURE' as const;
export const GET_RESERVE_HISTORY_INITIAL = 'GET_RESERVE_HISTORY_INITIAL' as const;
// 予約履歴明細取得
export const RESERVE_HISTORY_DETAIL_STATE = 'RESERVE_HISTORY_DETAIL_STATE' as const;
export const RESERVE_HISTORY_DETAIL_STATE_INIT = 'RESERVE_HISTORY_DETAIL_STATE_INIT' as const;
export const GET_RESERVE_HISTORY_DETAIL_REQUEST = 'GET_RESERVE_HISTORY_DETAIL_REQUEST' as const;
export const GET_RESERVE_HISTORY_DETAIL_SUCCESS = 'GET_RESERVE_HISTORY_DETAIL_SUCCESS' as const;
export const GET_RESERVE_HISTORY_DETAIL_FAILURE = 'GET_RESERVE_HISTORY_DETAIL_FAILURE' as const;
export const GET_RESERVE_HISTORY_DETAIL_INITIAL = 'GET_RESERVE_HISTORY_DETAIL_INITIAL' as const;
// 予約キャンセル
export const PUT_CANCEL_RESERVE_REQUEST = 'PUT_CANCEL_RESERVE_REQUEST' as const;
export const PUT_CANCEL_RESERVE_SUCCESS = 'PUT_CANCEL_RESERVE_SUCCESS' as const;
export const PUT_CANCEL_RESERVE_FAILURE = 'PUT_CANCEL_RESERVE_FAILURE' as const;
export const PUT_CANCEL_RESERVE_INITIAL = 'PUT_CANCEL_RESERVE_INITIAL' as const;
// 予約完了情報取得
export const VISITOR_COMPLETE_DISPATCH = 'VISITOR_COMPLETE_DISPATCH' as const;
export const VISITOR_COMPLETE_DISPATCH_INIT = 'VISITOR_COMPLETE_DISPATCH_INIT' as const;
